// TODO the popup should be extracted to dedicated component
mainApp.component('interfaceSelection', {
    templateUrl: '/public/directives/interface-selection.component.html',
    bindings: {
        id: '@',
        model: '=',
        immutable: '@',
        icons: '=',
        mouseenterevent: '&',
        mouseleaveevent: '&',
        errors: "="
    },
    controller: interfaceSelectionController
});

function interfaceSelectionController($scope, $state, NetworkRulesService) {
    var ctrl = this;

    ctrl.anyInterface = {
        label: 'Any',
        value: 'Any',
        description: 'Applicable for any interface across all site types'
    }

    ctrl.$onInit = function() {
        ctrl.interfacesUpdated = new Date().getTime();

        ctrl.assignModel();

        ctrl.origin = ctrl.model;
    }

    ctrl.$doCheck = function() {
        if (ctrl.origin === ctrl.model)
            return;

        ctrl.assignModel();

        ctrl.origin = ctrl.model;
    }

    ctrl.assignModel = function() {
        if (ctrl.model) {
            ctrl.selectedItems = ctrl.convertFromModel(ctrl.model);
        } else {
            ctrl.selectedItems = [ctrl.anyInterface];
        }

        ctrl.addItems();
    }

    ctrl.convertFromModel = function(idsArray) {
        return NetworkRulesService.getNICOptionsIds(idsArray);
    }

    ctrl.convertToModel = function(optionsArray) {
        if (_.find(ctrl.selectedItems, {value: 'Any'}))
            return [];

        return optionsArray.map(function(e) {
            return e.value
        });
    }

    ctrl.selectInterface = function(item, field, id) {
        NetworkRulesService.getNICOptionsForQuality($state.params.accountId, function(data) {
            ctrl.options = data
            ctrl.options.splice(0, 0, ctrl.anyInterface)
            ctrl.options.forEach(function(option) {
                option.name = option.label;
            });

            ctrl.interfacesUpdated = new Date().getTime();

            $scope.$root.openPopup(ctrl.id + '-add');
        });
    }

    ctrl.closeSelection = function() {
        $scope.$root.closePopup(ctrl.id + '-add');
    }

    ctrl.addItems = function() {
        // if 'Any' or nothing is selected, only 'Any' to stay
        var anyInterface = _.find(ctrl.selectedItems, {value: 'Any'})
        if (anyInterface || ctrl.selectedItems.length == 0)
            ctrl.selectedItems = [ctrl.anyInterface];

        ctrl.chosenItems = angular.copy(ctrl.selectedItems);
        ctrl.model = ctrl.convertToModel(ctrl.chosenItems)
        ctrl.closeSelection();
    }

    ctrl.interfacesConfig = {
        fixedLayout: true,
        titleSearch: false,
        fields: [{ label: 'Name', path: 'name', template: '<span>{{item.label}}</span>' },
                 { label: 'Description', path: 'description', template: '<span>{{item.description}}</span>' }],
        dataURL : function() {
            return null;
        },
        parseData: function(data) {
            return ctrl.options;
        },
        selectIdentifier: 'item',
        type: 'NIC',
        actions: [],
        clientSidePaging: true,
        clientSideSearch: true,
        clientSideSort: true,
        noSearch: true
    };
};

